<template>
  <el-container class="admin-shell">
    <el-aside width="220px" class="aside">
      <div class="brand">
        <span class="dot" />
        彩票后台
      </div>
      <el-menu
        :default-active="active"
        router
        background-color="#1b1f2a"
        text-color="#c5c9d4"
        active-text-color="#ffffff"
      >
        <el-menu-item index="/admin/dashboard">
          <el-icon><Odometer /></el-icon>
          <span>运营总览</span>
        </el-menu-item>
        <el-menu-item index="/admin/reports">
          <el-icon><TrendCharts /></el-icon>
          <span>盈亏报表</span>
        </el-menu-item>
        <el-menu-item index="/admin/games">
          <el-icon><Grid /></el-icon>
          <span>彩种管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/game-visibility">
          <el-icon><View /></el-icon>
          <span>前端展示</span>
        </el-menu-item>
        <el-menu-item index="/admin/platform-entry">
          <el-icon><Link /></el-icon>
          <span>平台入口</span>
        </el-menu-item>
        <el-menu-item index="/admin/odds">
          <el-icon><Ticket /></el-icon>
          <span>玩法赔率</span>
        </el-menu-item>
        <el-menu-item index="/admin/draws">
          <el-icon><Timer /></el-icon>
          <span>开奖期号</span>
        </el-menu-item>
        <el-menu-item index="/admin/draw-source">
          <el-icon><Connection /></el-icon>
          <span>开奖源切换</span>
        </el-menu-item>
        <el-menu-item index="/admin/orders">
          <el-icon><List /></el-icon>
          <span>注单管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/players">
          <el-icon><User /></el-icon>
          <span>玩家账户</span>
        </el-menu-item>
        <el-menu-item index="/admin/recommend">
          <el-icon><Star /></el-icon>
          <span>推荐热门</span>
        </el-menu-item>
        <el-menu-item index="/admin/announcements">
          <el-icon><Bell /></el-icon>
          <span>公告管理</span>
        </el-menu-item>
        <el-menu-item index="/admin/merchant">
          <el-icon><Setting /></el-icon>
          <span>商户设置</span>
        </el-menu-item>
      </el-menu>
    </el-aside>
    <el-container>
      <el-header class="header">
        <div class="crumb">{{ title }}</div>
        <div class="right">
          <span class="who">{{ me.name || me.username }}</span>
          <el-button text type="danger" @click="logout">退出</el-button>
        </div>
      </el-header>
      <el-main class="main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script setup>
import { computed, onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { adminApi, setAdminToken } from '../api'

const route = useRoute()
const router = useRouter()
const me = ref({ username: 'admin', name: '' })
const titles = {
  '/admin/dashboard': '运营总览',
  '/admin/reports': '盈亏报表',
  '/admin/games': '彩种管理',
  '/admin/game-visibility': '前端展示控制',
  '/admin/platform-entry': '平台入口（GET）',
  '/admin/odds': '玩法赔率',
  '/admin/draws': '开奖期号',
  '/admin/draw-source': '开奖源切换',
  '/admin/orders': '注单管理',
  '/admin/players': '玩家账户',
  '/admin/recommend': '推荐热门',
  '/admin/announcements': '公告管理',
  '/admin/merchant': '商户设置'
}
const active = computed(() => route.path)
const title = computed(() => titles[route.path] || '后台管理')

onMounted(async () => {
  try {
    me.value = await adminApi('/me')
  } catch {
    setAdminToken('')
    router.replace('/admin/login')
  }
})

const logout = () => {
  setAdminToken('')
  router.replace('/admin/login')
}
</script>

<style scoped>
.admin-shell {
  min-height: 100vh;
}
.aside {
  background: #1b1f2a;
  color: #fff;
}
.brand {
  height: 56px;
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 0 20px;
  font-weight: 700;
  letter-spacing: 0.04em;
  border-bottom: 1px solid rgba(255, 255, 255, 0.06);
}
.dot {
  width: 10px;
  height: 10px;
  border-radius: 50%;
  background: #f42c4c;
}
.header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: #fff;
  border-bottom: 1px solid #eef0f3;
}
.crumb {
  font-size: 16px;
  font-weight: 600;
}
.right {
  display: flex;
  align-items: center;
  gap: 8px;
}
.who {
  color: #666;
  font-size: 13px;
}
.main {
  background: #f4f6f9;
}
.el-menu {
  border-right: none;
}
</style>
